import { render, staticRenderFns } from "./HomeLinkItem.vue?vue&type=template&id=53596acf&"
import script from "./HomeLinkItem.vue?vue&type=script&lang=js&"
export * from "./HomeLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports